import type { Filter } from '#layers/data-model/public';

/**
 * Build the listing-drawer filter for an assignment picker (policy/role).
 *
 * Combines two id constraints on a single `id` field, which the engine and the local
 * cache matcher both AND together:
 * - `_nin` excludes already-effective ids (already assigned or pending).
 * - `_in` restricts to the ids the user may assign; `'*'` means all, so no `_in` is added.
 *
 * Returns `undefined` when neither constraint applies (every id is assignable and nothing
 * is excluded), leaving the drawer unfiltered.
 */
export function buildAssignmentFilter(allowedIds: string[] | '*', excludedIds: string[]): Filter | undefined {
	const idConstraints: Record<string, unknown> = {};

	if (excludedIds.length > 0) idConstraints._nin = excludedIds;
	if (allowedIds !== '*') idConstraints._in = allowedIds; // '*' = all allowed, no _in constraint

	return Object.keys(idConstraints).length > 0 ? { id: idConstraints } : undefined;
}
